import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_STAFF_EDITED_TOTAL_PAY } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const staffEditedTotalPay = {
  namespaced: true,
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus
  },
  actions: {
    getStaffEditedTotalPay ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting total pay, please wait...' })
      return api.doGet({ path: PATH_STAFF_EDITED_TOTAL_PAY, parameters: filters })
        .then(json => json.data)
        .then(editedTotalPay => {
          commit('updateStatus', { status: COMPLETE })
          hideProgressModal({ dispatch })
          return editedTotalPay[0]
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to get total pay')
        })
    },
    saveStaffEditedTotalPay ({ commit, dispatch }, editedTotalPay) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving total pay, please wait...' })

      return api.doPost({ path: PATH_STAFF_EDITED_TOTAL_PAY, data: editedTotalPay })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save total pay.')
          }

          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Total pay saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to save total pay')

          throw error
        })
    },
    updateStaffEditedTotalPay ({ commit, dispatch }, editedTotalPay) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving total pay, please wait...' })

      return api.doPut({ path: PATH_STAFF_EDITED_TOTAL_PAY, data: editedTotalPay })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save total pay.')
          }

          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Total pay saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to save total pay')

          throw error
        })
    }
  }
}

export default staffEditedTotalPay
